module.exports = __webpack_public_path__ + "static/img/step 2.0c48711.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step 2.gif
// module id = 3W7x
// module chunks = 1